import { useEffect, useState } from "react";
import { usePwaInstall } from "./usePwaInstall.js";

export default function PwaInstallNotice() {
  const { canInstall, installed, requestInstall } = usePwaInstall();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (installed) {
      setVisible(false);
      return;
    }
    const timeout = window.setTimeout(() => setVisible(true), 1150);
    return () => window.clearTimeout(timeout);
  }, [installed]);

  if (!visible || installed) return null;

  const install = async () => {
    if (!canInstall) return;
    const result = await requestInstall();
    if (result === "unavailable") setVisible(false);
  };

  return (
    <aside className="pwa-install-notice" aria-label="Instalar PuntoPY" aria-live="polite">
      <div className="pwa-install-notice-copy">
        <span className="pwa-install-notice-icon" aria-hidden="true">↓</span>
        <div>
          <strong>Instalá PuntoPY</strong>
          <p>Usalo como una app, sin descargar una APK externa.</p>
        </div>
      </div>
      <div className="pwa-install-notice-actions">
        {canInstall ? <button className="pwa-install-notice-primary" type="button" onClick={() => void install()}>Instalar ahora</button> : <a className="pwa-install-notice-primary" href="/descargar">Ver cómo instalar</a>}
        <button className="pwa-install-notice-close" type="button" aria-label="Cerrar aviso de instalación" onClick={() => setVisible(false)}>×</button>
      </div>
    </aside>
  );
}
